import Vue from 'vue';
import Vue2Filters from 'vue2-filters';

Vue.use(Vue2Filters, {
  currency: {
    symbol: 'R$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
  },
});

export default Vue;